module.exports = __webpack_public_path__ + "img/11.3788ee4d.jpeg";